import Vuex from "vuex";
import userVUEX from "./modules/userVUEX.js";
import topicVUEX from "./modules/topicVUEX.js";
import testVUEX from "./modules/testVUEX.js";
import sectionVUEX from "./modules/sectionVUEX.js";
import questionVUEX from "./modules/questionVUEX.js";
import searchVUEX from "./modules/searchVUEX.js";
import autotestVUEX from "./modules/autotestVUEX";
import permission from "./modules/permission.js";
import proctoringVUEX from "./modules/proctoringVUEX.js";
import getters from "./getters";
import sandboxVUEX from "./modules/sandboxVUEX.js";

export default new Vuex.Store({
	modules: {
		userVUEX,
		searchVUEX,
		topicVUEX,
		testVUEX,
		sectionVUEX,
		questionVUEX,
		autotestVUEX,
		proctoringVUEX,
		permission,
		sandboxVUEX,
	},
	getters,
});
